import React from 'react';
import ReactMarkdown from 'react-markdown';
import GFM from 'remark-gfm';

interface Props {
  children: string;
}

export const RichText: React.FC<Props> = props => (
  <ReactMarkdown {...props} remarkPlugins={[GFM]} />
);
